import { useQuery } from "@tanstack/react-query";
import { UsersAPI } from "@/admin/api";
import { PageHeader } from "@/components/admin/ui";

const Roles = () => {
  const { data: roles = [], isLoading } = useQuery({ queryKey: ["roles"], queryFn: UsersAPI.getRoles });

  if (isLoading) return <div className="p-8 text-cream/50">Loading roles...</div>;

  return (
    <div data-testid="admin-roles">
      <PageHeader title="ROLES" sub="Who may do what, inside the house." />

      <div className="border-t border-cream/10 mt-8">
        <div className="hidden grid-cols-12 gap-4 border-b border-cream/10 py-3 font-body text-[9px] tracking-[0.3em] uppercase text-cream/40 md:grid">
          <span className="col-span-2">Role ID</span>
          <span className="col-span-10">Role Name</span>
        </div>
        {roles.map((r) => (
          <div key={r.roleId} data-testid={`role-row-${r.roleName?.toLowerCase()}`} className="grid grid-cols-2 gap-3 border-b border-cream/10 py-4 md:grid-cols-12 md:items-center md:gap-4">
            <span className="font-body text-xs text-cream/40 md:col-span-2">R-{String(r.roleId).padStart(2, "0")}</span>
            <span className="font-display text-lg text-cream md:col-span-10">{r.roleName}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Roles;
